var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"spinner-container"},[_c('div',[_c('b-spinner',{attrs:{"variant":"primary"}})],1),_c('div',{staticStyle:{"margin-left":"5px"}},[_c('span',[_vm._v(_vm._s(_vm.$gettext('Deleting your account...')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }